export const STAFF_PERMISSION_REQUIRED_MESSAGE =
  '이 동작에는 권한이 필요합니다. 관리자에게 요청하세요.';

export const STAFF_NO_ENTRY_MESSAGE = '접근 권한이 없습니다.';

const DENIED_PREFIX = 'staff-scope-denied:';

/**
 * 403 응답 본문에서 인가 거부 사유를 꺼낸다. 인가 거부가 아니면 `null`.
 * 서버는 `ForbiddenException('staff-scope-denied:<reason>')` 을 던지므로 본문 `message` 가 문자열이다.
 */
export function parseStaffScopeDenyReason(body: unknown): string | null {
  if (typeof body !== 'object' || body === null) return null;
  const message = (body as Record<string, unknown>)['message'];
  if (typeof message !== 'string' || !message.startsWith(DENIED_PREFIX)) return null;
  return message.slice(DENIED_PREFIX.length);
}
